import {take, call, put, select} from 'redux-saga/effects'
import {SENDING_USER_CHANGE_PASSWORD, USER_CHANGE_PASSWORD_REQUEST, USER_CHANGE_PASSWORD_FAILURE, LOGIN_REQUEST} from '../actions/constants'

import user from '../api/user'
import {putNotify} from './utils'

const getTokenFromState = (state) => state.user.currentUser.token;
const getSystemIDFromState = (state) => state.system.currentSystem.ID;

function* updatePassword({token, systemID, newPasswordState}) {
  yield put({type: SENDING_USER_CHANGE_PASSWORD, sending: true})
  try {
    return yield call(user.updatePassword, token, systemID, newPasswordState)
  } catch (error) {
    yield put({type: USER_CHANGE_PASSWORD_FAILURE, error: error.message})
    return error
  } finally {
    yield put({type: SENDING_USER_CHANGE_PASSWORD, sending: false})
  }
}

export function* watchUpdatePasswordRequest() {
  while (true) {
    const {newPasswordState} = yield take(USER_CHANGE_PASSWORD_REQUEST)
    const token = yield select(getTokenFromState);
    const systemID = yield select(getSystemIDFromState);
    const response = yield call(updatePassword, {token, systemID, newPasswordState})
    if (response && response.error) {
      yield put({type: USER_CHANGE_PASSWORD_FAILURE, error: response.error})
    } else {
      const notify = `Đổi mật khẩu thành công!`
      yield call(putNotify, {response, notify})
      const dataLogin = {
        username: newPasswordState.UserName,
        password: newPasswordState.NewPassword,
        remember: false,
        nextUrl: "/"
      }
      yield put({type: LOGIN_REQUEST, data: dataLogin})
    }
  }
}



// WEBPACK FOOTER //
// ./src/sagas/user.js